import { useState } from "react";
import { IoEyeOffOutline, IoEyeOutline } from "react-icons/io5";
import Button from "component/ui/Button";
import logo from "../../assets/logo-2.png";
import { MdClose } from "react-icons/md";
import InputWithIcon from "component/ui/InputWithIcon";
import { useDispatch } from "react-redux";
import { changePassword } from "store/slice/auth";
import FullPageLoader from "component/ui/fullPageLoader";

const ChangePassword = ({ onCancel, setIsPasswordModalOpen }) => {
  const [formData, setFormData] = useState({
    currentPassword: "",
    newPassword: "",
    showNewPassword: false,
    showCurrentPassword: false,
  });
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  // handle change password success
  const handleSuccess = (status) => {
    if (status) {
      onCancel();
    }
    setIsLoading(false);
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData?.currentPassword) {
      setFormData((formData) => ({
        ...formData,
        currentPasswordError: "Please enter current password",
      }));
      return;
    }
    if (formData?.currentPassword?.length < 8) {
      setFormData((formData) => ({
        ...formData,
        currentPasswordError: "Password must have a minimum 8 character",
      }));
      return;
    }
    if (!formData?.newPassword) {
      setFormData((formData) => ({
        ...formData,
        newPasswordError: "Please enter new password",
      }));
      return;
    }
    if (formData?.newPassword?.length < 8) {
      setFormData((formData) => ({
        ...formData,
        newPasswordError: "Password must have a minimum 8 character",
      }));
      return;
    }
    setIsLoading(true);
    let request = {
      language: "en",
      currentPassword: formData?.currentPassword,
      newPassword: formData?.newPassword,
    };
    dispatch(changePassword(request, handleSuccess));
  };

  const handleChange = (name, value) => {
    setFormData((prev) => ({
      ...prev,
      [name]: value,
      [`${name}Error`]: "",
    }));
  };

  return (
    <div
      className="bg-white rounded-xl shadow-2xl max-w-xl w-[95%] mx-auto md:px-5 px-3 pb-5 pt-2 animate-in fade-in zoom-in-50"
      onClick={(e) => e.stopPropagation()}
    >
      {isLoading && <FullPageLoader />}
      <form onSubmit={handleSubmit}>
        {/* <div className=" mb-4"> */}
        <button
          onClick={() => setIsPasswordModalOpen(false)}
          className="text-gray-400 hover:text-gray-600 rounded-full transition-colors flex items-end justify-end w-full"
          aria-label="Close"
        >
          <MdClose size={24} />
        </button>

        {logo && <img src={logo} alt="Logo" className="w-40 mx-auto" />}

        <h3 className="text-2xl font-semibold text-center text-gray-800 my-3">
          Change Password
        </h3>
        <p className="text-sm text-center text-gray-500 mb-5">
          Your new password must be different from previous.
        </p>

        {/* 1. Current Password */}
        <div className="relative mb-4">
          <InputWithIcon
            type={formData?.showCurrentPassword ? "text" : "password"}
            placeholder="Enter current password"
            value={formData.currentPassword}
            onChange={(val) => handleChange("currentPassword", val)}
            required
            onEndIconClick={() =>
              setFormData((formData) => ({
                ...formData,
                showCurrentPassword: !formData?.showCurrentPassword,
              }))
            }
            error={formData?.currentPasswordError}
            endIcon={
              formData?.showCurrentPassword ? (
                <IoEyeOutline size={20} />
              ) : (
                <IoEyeOffOutline size={20} />
              )
            }
            className="text-black"
          />
        </div>

        {/* 2. New Password */}
        <div className="relative mb-4">
          <InputWithIcon
            type={formData?.showNewPassword ? "text" : "password"}
            placeholder="Enter new password"
            value={formData.newPassword}
            onChange={(val) => handleChange("newPassword", val)}
            required
            className="text-black"
            onEndIconClick={() =>
              setFormData((formData) => ({
                ...formData,
                showNewPassword: !formData?.showNewPassword,
              }))
            }
            error={formData?.newPasswordError}
            endIcon={
              formData?.showNewPassword ? (
                <IoEyeOutline size={20} />
              ) : (
                <IoEyeOffOutline size={20} />
              )
            }
          />
        </div>

        {/* Action Buttons */}
        <div className="flex justify-end items-center md:space-x-3 space-x-1 pt-4">
          <Button
            fullWidth
            type="button"
            variant="secondary"
            onClick={onCancel}
          >
            Cancel
          </Button>

          <Button 
          fullWidth
           type="submit">
            Update Password
          </Button>
        </div>
      </form>
    </div>
  );
};

export default ChangePassword;
